import { createContext } from 'react';

export type ModalContextType = {
  closeModal: (isSuccess?: boolean, data?: unknown) => void;
};

export const ModalContext = createContext<ModalContextType>({
  closeModal: () => {
    return null;
  },
});
